import { Injectable } from '@angular/core';
import { AbstractSimpleListViewService } from '@examdojo/core/list-view';
import { PayoutRequestUIModel } from '@examdojo/payments';
import { of } from 'rxjs';

@Injectable()
export class PaymentRequestsListService extends AbstractSimpleListViewService<PayoutRequestUIModel> {
  constructor() {
    super();
  }

  readonly data$ = of([]);
  readonly loading$ = of(false);
  override hasItems$ = of(true);
}
